import { create } from "zustand";
import { baseURL } from "../../../baseUrl";
import axios from 'axios';
import { toast } from 'react-toastify';

export const useLocations = create((set, get) => ({
    countryes: [],
    provinses: [],
    cities: [],
    parish: [],
    subAreas: [],
    countryByParentId: [],
    provinceByParentId: [],
    cityByParentId: [],
    parishByParentId: [],
    subAreaByParentId: [],
    loader: false,
    areas: [],
    locationName: "",



    actions: {
        getLocationByParentId: async (parentId) => {
            // set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/CityState/GetLocationByParentId?parentId=${parentId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                   

                    // set((state) => ({ loader: false }))
                    set((state) => ({ areas: res.data }))
                })
        },
        getOneCountryes: async (parentId) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/CityState/GetLocationByParentId?parentId=${parentId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ countryByParentId: res.data }))
                }).catch((error) => {
                    console.error('Network Error:', error);
                });
        },
        getOneProvince: async (parentId) => {
            // set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/CityState/GetLocationByParentId?parentId=${parentId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    // set((state) => ({ loader: false }))
                    set((state) => ({ provinceByParentId: res.data }))
                })
        },
        getOneCity: async (parentId) => {
            // set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/CityState/GetLocationByParentId?parentId=${parentId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                   

                    // set((state) => ({ loader: false }))
                    set((state) => ({ cityByParentId: res.data }))
                })
        },

        getOneParish: async (parentId) => {
            // set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/CityState/GetLocationByParentId?parentId=${parentId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    // set((state) => ({ loader: false }))
                    set((state) => ({ parishByParentId: res.data }))
                    console.log({res});
                    
                })
        },
        getOneSubArea: async (parentId) => {
            // set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/CityState/GetLocationByParentId?parentId=${parentId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    // set((state) => ({ loader: false }))
                    set((state) => ({ subAreaByParentId: res.data }))
                })
        },


        getAllCountryes: async (masterId) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/CityState/GetLocationByMasterId?masterId=${masterId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ countryes: res.data }))
                }).catch((error) => {
                    if (error.code === "ERR_NETWORK") {
                        console.error('Network Error:', error);
                    
                    }
                });
        },
        removeCountry: async (id) => {
            await axios.post(`${baseURL}/CityState/DeleteLocationById?id=${id}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    if (res.data !== -2) {
                        set((state) => ({ countryes: state }))
                        toast('عملیات حذف موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('به دلیل دارا بودن زیر مجموعه امکان حذف وجود ندارد', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },
        editCountry: async (id, locName, locParentId, masterId) => {
            await axios.post(`${baseURL}/CityState/EditLocations?id=${id}`, {
                "id": id,
                "locName": locName,
                "locParentId": locParentId,
                "masterId": masterId
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات ویرایش موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات ویرایش موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },
        createCountry: async (locName) => {
            await axios.post(`${baseURL}/CityState/EditLocations?id=${0}`, {
                "locName": locName,
                "locParentId": 0,
                "masterId": 1
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات افزودن موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات افزودن موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },


        getAllProvinces: async (masterId) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/CityState/GetLocationByMasterId?masterId=${masterId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ provinses: res.data }))
                })
        },
        removeProvince: async (id) => {
            await axios.post(`${baseURL}/CityState/DeleteLocationById?id=${id}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    if (res.data !== -2) {
                        toast('عملیات حذف موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('به دلیل دارا بودن زیر مجموعه امکان حذف وجود ندارد', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },
        editProvince: async (id, locName, locParentId, masterId) => {
            await axios.post(`${baseURL}/CityState/EditLocations?id=${id}`, {
                "id": id,
                "locName": locName,
                "locParentId": locParentId,
                "masterId": masterId
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات ویرایش موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات ویرایش موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },
        createProvince: async (locName, parentId, centerLatitude, centerLongitude) => {
            await axios.post(`${baseURL}/CityState/EditLocations?id=${parentId}`, {
                "locName": locName,
                "locParentId": parentId,
                "masterId": 2,
                "centerLatitude": centerLatitude,
                "centerLongitude": centerLongitude,
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات افزودن موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات افزودن موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },


        getAllCities: async (masterId) => {
            set((state) => ({ loader: true }))
            axios.get(`${baseURL}/CityState/GetLocationByMasterId?masterId=${masterId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ cities: res.data }))
                })
        },
        removeCity: async (id) => {
            axios.post(`${baseURL}/CityState/DeleteLocationById?id=${id}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    if (res.data !== -2) {
                        toast('عملیات حذف موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('به دلیل دارا بودن زیر مجموعه امکان حذف وجود ندارد', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },
        editCity: async (id, locName, locParentId, masterId) => {
            await axios.post(`${baseURL}/CityState/EditLocations?id=${id}`, {
                "id": id,
                "locName": locName,
                "locParentId": locParentId,
                "masterId": masterId
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات ویرایش موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات ویرایش موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },
        createCity: async (locName, parentId, centerLatitude, centerLongitude) => {
            await axios.post(`${baseURL}/CityState/EditLocations?id=${parentId}`, {
                "locName": locName,
                "locParentId": parentId,
                "masterId": 3,
                "centerLatitude": centerLatitude,
                "centerLongitude": centerLongitude
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات افزودن موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات افزودن موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },


        getAllParishs: async (masterId) => {
            set((state) => ({ loader: true }))
            axios.get(`${baseURL}/CityState/GetLocationByMasterId?masterId=${masterId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ parish: res.data }))
                })
        },
        removeParishs: async (id) => {
            axios.post(`${baseURL}/CityState/DeleteLocationById?id=${id}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    if (res.data !== -2) {
                        toast('عملیات حذف موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('به دلیل دارا بودن زیر مجموعه امکان حذف وجود ندارد', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },
        editParishs: async (id, locName, locParentId, masterId) => {
            await axios.post(`${baseURL}/CityState/EditLocations?id=${id}`, {
                "id": id,
                "locName": locName,
                "locParentId": locParentId,
                "masterId": masterId
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات ویرایش موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات ویرایش موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },
        createParishs: async (locName, parentId) => {
            await axios.post(`${baseURL}/CityState/EditLocations?id=${0}`, {
                "locName": locName,
                "locParentId": parentId,
                "masterId": 4
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات افزودن موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات افزودن موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },


        getAllSubAreas: async (masterID) => {
            set((state) => ({ loader: true }))
            axios.get(`${baseURL}/CityState/GetLocationByMasterId?masterId=${masterID}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ subAreas: res.data }))
                })
        },
        getLocationById: async (Id) => {
            set((state) => ({ loader: true }))
            axios.get(`${baseURL}/CityState/GetLocationById?Id=${Id}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    console.log(res.data, " ********* ");

                    set((state) => ({ loader: false }))
                    set((state) => ({ locationName: res.data?.locName }))
                })
        },
        removeSubArea: async (id) => {
            axios.post(`${baseURL}/CityState/DeleteLocationById?id=${id}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {
                    if (res.data !== -2) {
                        toast('عملیات حذف موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('به دلیل دارا بودن زیر مجموعه امکان حذف وجود ندارد', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },
        editSubArea: async (id, locName, locParentId, masterId) => {
            await axios.post(`${baseURL}/CityState/EditLocations?id=${id}`, {
                "id": id,
                "locName": locName,
                "locParentId": locParentId,
                "masterId": masterId
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات ویرایش موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات ویرایش موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },
        createSubArea: async (locName, parentId) => {
            await axios.post(`${baseURL}/CityState/EditLocations?id=${0}`, {
                "locName": locName,
                "locParentId": parentId,
                "masterId": 5
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات افزودن موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات افزودن موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },


    }
}))
